// extracted by mini-css-extract-plugin
module.exports = {"root":"Timetable_root_1GWxn"};